import React, { useState, useEffect } from 'react';
import { Row, Col, FloatingLabel, Tooltip, OverlayTrigger,
  Form, Dropdown, DropdownButton,
  Button, ButtonGroup, Modal, Offcanvas  } from 'react-bootstrap';
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";




import uploadIcon from '../../dist/images/icons/upload.png'

const App = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const navigate = useNavigate();
  const {id} = useParams()


  const [recordData, setRecordData] = useState({
    name: '',
    categoryType: null,
    category: null,
    account: null,
    date: new Date(),
    amount: ''
  })

  
  


  const isCreatePage = location.pathname.includes('records/create/') || location.pathname.includes('records/edit/');
  const isDashboardPage = location.pathname.includes('dashboard/');

  const [addShow, setAddShow] = useState(false);
  const handleAddClose = () => onCloseFrom();
  const handleAddShow = () => setAddShow(true);

    



  const [error, setError] = useState({});
  const [editId, setEditId] = useState(null);

  const [categoryOptions, setCategoryOptions] =useState([])

  // useEffect(() => {
  //   console.log("RecordData", recordData, categoryOptions)
  // }, [recordData, categoryOptions])



  const onCloseFrom = () => {
    setRecordData({
      name: '',
      categoryType: null,
      category: null,
      account: null,
      date: new Date(),
      amount: ''
    });
    setError({});
    setAddShow(false);
    if(isDashboardPage) {
      navigate('/dashboard/', { state: { onFetchData: true } })
    } else {
      navigate('/records/', { state: { onFetchData: true } })
    }    
    setEditId(null)
  }

  const accountOption = [
  {id:1, value :"Cash"},
  {id : 2, value :"Debit Card"},
  {id :3, value :"Credit Card"},
  ]

  const categoryTypeOption = [
  {id:1, value :"Expense"},
  {id : 2, value :"Income"},  
  ]

  useEffect(() => {
    if(id){
      setEditId(id)
    }
  }, [id])

  useEffect(() => {
    if(isCreatePage || (isCreatePage && editId)){
      setAddShow(true)
    }
    if(isCreatePage && editId){
      fetchEditData()
    }
  }, [isCreatePage, editId])

  useEffect(()=>{
    axios.get(`${apiUrl}Category/`)
    .then(response => {
      //console.log(response.data);
      const data = response.data;
      setCategoryOptions(data)

    })
    .catch(error => {
      console.error('Error fetching data: ', error,);
    });
  },[])


  const fetchEditData = () => {
    axios.get(`${apiUrl}Records/${editId}`)
    .then(response => {
      // console.log(response.data);
      const data = response.data;
      setRecordData(data)


    })
    .catch(error => {
      console.error('Error fetching data: ', error,);

    });
  }

  


  const validation = () => {
    const newError = {};
    if (!recordData.name.trim()) {
      newError.name = "Name is required";
    }
    if (!recordData.category) {
      newError.category = "Category is required";
    }
    if (!recordData.date) {
      newError.date = "Date is required";
    }
    if (!recordData.account) {
      newError.account = "Account is required";
    }
    if (!recordData.amount) {
      newError.amount = "Amount is required";
    }
    return newError;
  };

  const handleCreateTemplateSubmit = async (e) => {
    e.preventDefault();
    const validationForm = validation();

    if (Object.keys(validationForm).length > 0) {
      setError(validationForm);
    } else {
      


      let sendApi = `${apiUrl}/Records/`
      if (editId) {
        sendApi = `${apiUrl}/Records/${editId}`
      }

      const method = editId ? 'put' : 'post';

      axios({
          method: method, 
          url: sendApi,
          data: recordData, 
        })
        .then((response) => {
          onCloseFrom()          
          toast.success("Records Data Submitted")

        })
        .catch((error) => {
          toast.warning("Network Issue. Try again later")
          onCloseFrom() 
          console.error("Error submitting form:", error, `${process.env.REACT_APP_API}/Category/`, recordData);
        });
    }
  };

  

  const handleRecordDataChange = (value, field) => {

    setRecordData(prevData => ({
      ...prevData,
      [field]: value
    }))


    setError(prevError => ({
      ...prevError,
      [field]: ''
    }))

  }

  return (
    <>
      <Offcanvas
        show={addShow}
        onHide={handleAddClose}
        placement="end"
        size="lg"
        style={{
          height: "100vh", // Fill full height
          width: "700px",
        }}
      >
        <Offcanvas.Header closeButton >
          <Offcanvas.Title><h4 className="fw-bold mt-2 ms-4">Create Records</h4></Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form onSubmit={handleCreateTemplateSubmit} className="bgWhite px-4" id="myForm">
            <Row>
              <Col xs={12}>
                
                <Form.Group className="mb-5 " controlId="floatingInput">
                  <div className="frm-group"> 
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    onChange={(e) => handleRecordDataChange(e.target.value, 'name')}
                    value={recordData.name}
                  />
                  </div>
                  {error.name && <p className="errors mt-2">{error.name}</p>}
                </Form.Group>


                <Form.Group className="mb-5">
              <div className="frm-group">
                <Form.Label>Category Type</Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  className="form-control"
                  onChange={(e) => handleRecordDataChange(e.target.value, 'categoryType')}
                  value={recordData.categoryType}
                >
                 <option value={null}>Select Category Type</option>
                  {categoryTypeOption?.map(item => (
                    <option key={item.id} value={item.id}>{item.value}</option>
                    ))}
                </Form.Select>
              </div>
              {error.type && <p className="errors">{error.type}</p>}
            </Form.Group>

                

                {/* Dropdown */}
             <Form.Group className="mb-5">
              <div className="frm-group">
                <Form.Label>Category</Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  className="form-control"
                  onChange={(e) => handleRecordDataChange(e.target.value, 'category')}
                  value={recordData.category}
                >
                <option value={null}>Select Category</option>
                {categoryOptions?.filter(item => parseInt(item.Category_type) === parseInt(recordData?.categoryType))?.map(item => (
                   
                // {categoryOptions?.map(item => (
                  <option key={item.id} value={item.id}>{item.Category}</option>
                  ))}                  
                </Form.Select>
              </div>
              {error.category && <p className="errors">{error.category}</p>}
            </Form.Group>


            <Form.Group className="mb-5">
              <div className="frm-group">
                <Form.Label>Account</Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  className="form-control"
                  onChange={(e) => handleRecordDataChange(e.target.value, 'account')}
                  value={recordData.account}
                >
                 <option value={null}>Select Account</option>
                  {accountOption?.map(acc => (
                    <option key={acc.id} value={acc.id}>{acc.value}</option>
                    ))}
                </Form.Select>
              </div>
              {error.account && <p className="errors">{error.account}</p>}
            </Form.Group>


            


            <Form.Group className="mb-5">
              <div className="frm-group">
                <Form.Label>Date</Form.Label>
                <br/>
                <DatePicker
                selected={recordData.date}
                onChange={(date) => handleRecordDataChange(date, 'date')}
                className="form-control"                
                dateFormat="yyyy-MM-dd"
              />
              </div>
              {error.date && <p className="errors">{error.date}</p>}
            </Form.Group>


            
            

            <Form.Group className="mb-5 " controlId="floatingInput">
                  <div className="frm-group"> 
                  <Form.Label>Amount</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    onChange={(e) => handleRecordDataChange(e.target.value, 'amount')}
                    value={recordData.amount}
                  />
                  </div>
                  {error.amount && <p className="errors mt-2">{error.amount}</p>}
                </Form.Group>            

                

                <Col md="auto" className="text-end">
                  <button type="submit" className="btn-green my-3">
                    Save
                  </button>
                </Col>
              </Col>
            </Row>
          </form>
          
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default App;
